// extracted by mini-css-extract-plugin
export var parcelRow = "_sa-0";